import { http } from "@/utils";

const inviteCode = {
  /**
   * 查询邀请码
   * @param data
   * @return {*}
   */
  selectInvitationCodeInfo(data) {
    let url = "/uuos/select_invitation_code_info";
    return http.post(url, data).then((res) => res.data);
  },
  /**
   * 申请使用邀请码
   * @param data
   * @return {*}
   */
  useInvitationCode(data) {
    let url = "/uuos/use_invitation_code";
    return http.post(url, data).then((res) => res.data);
  },
  /**
   * 根据手机号查询用户
   * @param data
   * @return {*}
   */
  queryUserInfo(data) {
    let url = "/uuos/c_mobile_get_user";
    return http.post(url, data).then((res) => res.data);
  },
  /**
   * 申请使用邀请码
   * @param data
   * @return {*}
   */
  duplicateName(data) {
    let url = "/ops-api/branch/check/duplicate_name";
    return http.post(url, data).then((res) => res.data);
  },
};

export default inviteCode;
